import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { MpsRoleGuard } from '../mps/guards/mps-role.guard';
import { MpsPermissionHelper } from '../mps/helpers/mps-permission.helper';
import { MpsUserService } from '../mps/services/mps-user.service';
import { applicationRouteNames } from './application-route-names';
import { UnsavedChangesGuard } from './gestion-modeles/guards/unsaved-changes.guard';
import { MpsRoleHelper } from './helpers/mps-role.helper';
import { MpsUser } from './models/mps-user.model';

/**
 * Page d'accueil selon le rôle : le recruteur arrive sur ses formulaires, l'équipe contrat et l'admin sur l'historique.
 * Calculée à la redirection (contexte d'injection), donc après connexion.
 */
const homeRoute = (): string => {
  const user = inject(MpsUserService).getUser();

  return user ? MpsPermissionHelper.defaultRouteFor(new MpsUser(user)) : applicationRouteNames.historiqueContrats;
};

export const applicationRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: homeRoute },
  { path: 'home', pathMatch: 'full', redirectTo: homeRoute },
  {
    path: applicationRouteNames.nouvelleDemande,
    loadChildren: () => import('./nouvelle-demande/nouvelle-demande.routes').then((m) => m.nouvelleDemandRoutes),
    data: { title: 'general.navigation.nouvelle_demande', roles: [MpsRoleHelper.RECRUTEUR, MpsRoleHelper.ADMIN] },
    canActivate: [MpsLoggedInGuard, MpsRoleGuard],
    canLoad: [],
  },
  {
    path: applicationRouteNames.historiqueContrats,
    loadChildren: () =>
      import('./historique-contrats/historique-contrats.routes').then((m) => m.historiqueContratsRoutes),
    data: {
      title: 'general.navigation.historique_contrats',
      roles: [MpsRoleHelper.EQUIPE_CONTRAT, MpsRoleHelper.ADMIN],
    },
    canActivate: [MpsLoggedInGuard, MpsRoleGuard],
    canLoad: [],
  },
  {
    path: applicationRouteNames.gestionModeles,
    loadComponent: () => import('./gestion-modeles/gestion-modeles.component').then((m) => m.GestionModelesComponent),
    data: { title: 'general.navigation.gestion_modeles', roles: [MpsRoleHelper.ADMIN] },
    canActivate: [MpsLoggedInGuard, MpsRoleGuard],
    canDeactivate: [UnsavedChangesGuard],
    canLoad: [],
  },
  {
    path: applicationRouteNames.revueContrats,
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import('./revue-contrats/revision-contrat/revision-contrat.component').then(
            (m) => m.RevisionContratComponent
          ),
        data: { title: 'pages.revision_contrat.title', roles: [MpsRoleHelper.EQUIPE_CONTRAT, MpsRoleHelper.ADMIN] },
        canActivate: [MpsLoggedInGuard, MpsRoleGuard],
        canLoad: [],
      },
    ],
    data: { roles: [MpsRoleHelper.EQUIPE_CONTRAT, MpsRoleHelper.ADMIN] },
    canActivate: [MpsLoggedInGuard, MpsRoleGuard],
    canLoad: [],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'general.navigation.administration', roles: [MpsRoleHelper.ADMIN] },
    canActivate: [MpsLoggedInGuard, MpsRoleGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.users', roles: [MpsRoleHelper.ADMIN] },
        canActivate: [MpsLoggedInGuard, MpsRoleGuard],
      },
      {
        path: applicationRouteNames.lokalise,
        loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
        data: { title: 'general.navigation.lokalise', roles: [MpsRoleHelper.ADMIN] },
        canActivate: [MpsLoggedInGuard, MpsRoleGuard],
      },
    ],
  },
];
